import React from 'react';

const jawOptions = [
  { 
    value: 'square', 
    label: 'Square', 
    maleImage: '/option_images/square jaw.png',
    femaleImage: '/option_images/square woman.png'
  },
  { 
    value: 'gently-rounded', 
    label: 'Gently Rounded', 
    maleImage: '/option_images/gently round jaw.png',
    femaleImage: '/option_images/gently round woman.png'
  },
  { 
    value: 'rounded', 
    label: 'Rounded', 
    maleImage: '/option_images/round jaw.jpg',
    femaleImage: '/option_images/round woman.png'
  },
  { 
    value: 'pointed', 
    label: 'Pointed', 
    maleImage: '/option_images/pointed jaw.png',
    femaleImage: '/option_images/pointed jaw woman.png'
  }
];

function JawShapeQuestion({ answer, onAnswerChange, questionId }) {
  //small change
  return (
    <div className="mb-6">
      <div className="flex flex-col gap-4">
        {jawOptions.map((option) => (
          <button
            key={option.value}
            onClick={() => onAnswerChange(questionId, option.value)}
            className={`rounded-xl overflow-hidden transition-all ${
              answer === option.value
                ? 'ring-4 ring-blue-500 shadow-lg'
                : 'ring-1 ring-gray-200 hover:ring-gray-400'
            }`}
          >
            <div className="py-2 px-4 bg-gray-100">
              <p className="text-lg font-bold text-center">{option.label}</p>
            </div>
            <div className="grid grid-cols-2 items-center bg-white">
              <img
                src={option.maleImage}
                alt={`${option.label} (Male)`}
                className="w-full h-auto"
              />
              <img
                src={option.femaleImage}
                alt={`${option.label} (Female)`}
                className="w-full h-auto"
              />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}

export default JawShapeQuestion;
